module.exports = __webpack_public_path__ + "b2f3ef4ef89f9509534f69a0f5883419.jpg";